import type { SkillData } from '../spacetime/modules/SkillModule';

const FIELD_SEPARATOR = '\u001f';
const RECORD_SEPARATOR = '\u001e';

export function buildSkillListSignature(skills: SkillData[]): string {
  return skills.map((skill) => [
    skill.skillId,
    skill.displayName,
    skill.description,
    skill.emoji,
    skill.damage,
    skill.range,
    skill.radius,
    skill.durationTicks,
    skill.cooldownTicks,
    skill.tags.join(','),
  ].join(FIELD_SEPARATOR)).join(RECORD_SEPARATOR);
}

export function buildSkillBarSignature(skillIds: string[]): string {
  return skillIds.join(FIELD_SEPARATOR);
}
